import { render } from "./CoordinatesModal.vue?vue&type=template&id=57911ad3&scoped=true"
import script from "./CoordinatesModal.vue?vue&type=script&lang=js"
export * from "./CoordinatesModal.vue?vue&type=script&lang=js"

import "./CoordinatesModal.vue?vue&type=style&index=0&id=57911ad3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57911ad3"]])

export default __exports__